import { render, staticRenderFns } from "./ShareLayer.vue?vue&type=template&id=791508bc&scoped=true&"
import script from "./ShareLayer.vue?vue&type=script&lang=js&"
export * from "./ShareLayer.vue?vue&type=script&lang=js&"
import style0 from "./ShareLayer.vue?vue&type=style&index=0&id=791508bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791508bc",
  null
  
)

export default component.exports